//
// Module for the Receivables Edit view
//
rs.module("content/employer/reporting/receivables/edit",

    [ /* dependencies */],

    function () {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, enablePostedDate) {

            if (enablePostedDate) {

                // Unpack js selectors
                var form = $.js(jsSelectors.form);
                var postedDatePicker = form.js(jsSelectors.postedDate, { required: false });
                var cancelledDatePicker = form.js(jsSelectors.cancelledDate, { required: false });

                // Enable posted date
                postedDatePicker.prop("disabled", false);

                // Re-run events in case of postback
                toggleEnable(postedDatePicker, cancelledDatePicker);
                toggleEnable(cancelledDatePicker, postedDatePicker);

                // Setup listeners to posted date & cancelled date so only one can be populated at a time.
                postedDatePicker.change(function () {
                    toggleEnable(postedDatePicker, cancelledDatePicker);
                });

                cancelledDatePicker.change(function () {
                    toggleEnable(cancelledDatePicker, postedDatePicker);
                });
            }
        }

        // Conditionally enable the 'dependency' based on the 'controller' state
        function toggleEnable(controller, dependency) {

            // If control is not populated, enable dependency
            if (controller.val() === '') {
                dependency.prop("disabled", false);
            }

            // Else control is populated, disable dependency
            else {
                dependency.prop("disabled", true);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);